import { z } from 'zod';
import { ItemIdSchema } from './items';

/**
 * What the station shows (MAGIC-FRAGMENT, UX-FRAGMENT): the fragments absorbed, how much of the
 * body they take and what it tolerates, and the saved loadouts.
 */
export const FragmentsViewSchema = z.object({
  /** Absorbed fragments, by item id (one of each at most). */
  body: z.array(ItemIdSchema),
  capacity: z.object({
    used: z.number().int().nonnegative(),
    total: z.number().int().nonnegative(),
  }),
  maxFragments: z.number().int().positive(),
  /** Demanding categories: how many absorbed, and how many the level tolerates. */
  tolerance: z.object({
    medium: z.object({
      used: z.number().int().nonnegative(),
      slots: z.number().int().nonnegative(),
    }),
    high: z.object({ used: z.number().int().nonnegative(), slots: z.number().int().nonnegative() }),
  }),
  loadouts: z.array(z.object({ name: z.string(), fragments: z.array(ItemIdSchema) })),
  maxLoadouts: z.number().int().nonnegative(),
  /** Coins a reassignment of attributes costs now (none while it is free). */
  respecCost: z.number().int().nonnegative(),
  /** The character holds a free reassignment (CHAR-ATTRIBUTE PK-2: the five attributes came). */
  freeRespec: z.boolean(),
});
export type FragmentsView = z.infer<typeof FragmentsViewSchema>;
